import React from "react";
import './footer.scss';
import { withRouter } from "react-router-dom";

export const Footer = withRouter(({ location }) => {
  const isInverted = location.pathname !== '/contact';
  return <div className={`footer ${isInverted ? 'footer--inverted' : ''}`}>BITNAG INC, 2019</div>;
});
